module.exports = __webpack_public_path__ + "img/910237letsbonus.5e80e553.jpg";